module.exports = __webpack_public_path__ + "static/media/pitch.1b30c26f.svg";